/**
 * Created by lari on 24/04/2017.
 */
(function () {
  'use strict';
  
  angular
    .module('vcexam')
    .config(config);
  
  config.$inject = ['$stateProvider'];
  
  function config($stateProvider) {
    $stateProvider
      .state('playground.exam', {
        url: '/exam',
        views: {
          'playgroundmain@playground': {
            template: '<h3><tt>&lt;examlist exams=""&gt;</tt></h3><div ui-view="examlistview"></div>' +
            '<h3><tt>&lt;examedit exam=""&gt;</tt></h3><div ui-view="exameditview"></div>' +
            '<h3><tt>&lt;examfield field="" on-field-change="" gi="" fi=""&gt;</tt></h3><div ui-view="examfieldview"></div>' +
            '<h3><tt>&lt;fieldgroup on-fieldgroup-change="" gi=""&gt;</tt></h3><div ui-view="examfieldgroupview"></div>' +
            '<h3><tt>&lt;examview exam=""&gt;</tt></h3><div ui-view="examview"></div>' +
            '<h3><tt>&lt;currentexams examinations=""&gt;</tt></h3><div ui-view="currentexamsview"></div>'
          }
        },
        onEnter: function () {
          console.log('playground.exam entered');
        }
      });
    
    
    $stateProvider
      .state('playground.exam.allcomponents', {
        url: '/allcomponents',
        // the `users` input binding on the component receives
        // the `userlist` resolve value (from the state)
        // bind $transistions to gain access to $transition$ object
        
        resolve: {
          exams: function (ExamHelper) {
            return ExamHelper.getAllClosed();
            // return {};
          },
          field: function () {
            return getfield(1);
          },
          fieldgroup: function () {
            return getfieldgroup('dummy group');
          },
          exam: function (ExamHelper) {
            // return ExamHelper.getOneOpen();
            return getExam(true, true);
          },
          currentexams: function() {
            return getExams();
          },
          onfieldchange: function () {
            return function () {
              console.log('dummy onfieldchange called');
            };
          },
          onfieldgroupchange: function () {
            return function () {
              console.log('dummy onfieldgroupchange called');
            };
          }
        },
        views: {
          // When `fooState.barState` is active, `fooComponent`
          // is loaded into the <ui-view name='content' />
          // which was created by `fooState`.
          // The component's `foo` input receives `fooData` resolve
          'examlistview@playground.exam': {
            component: 'examlist',
            bindings: {
              exams: 'currentexams'
            }
          },
          'examfieldview@playground.exam': {
            component: 'examfield',
            bindings: {
              field: 'field',
              onFieldChange: 'onfieldchange'
            } // bindings
          },
          'examfieldgroupview@playground.exam': {
            component: 'fieldgroup',
            bindings: {
              fieldgroup: 'fieldgroup',
              onFieldgroupChange: 'onfieldgroupchange'
            }
          },
          'exameditview@playground.exam': {
            component: 'exameditor',
            bindings: {
              exam: 'exam'
            }
          },
          'examview@playground.exam': {
            component: 'examview',
            bindings: {
              exam: 'exam'
            }
          },
          'currentexamsview@playground.exam': {
            component: 'currentexams',
            bindings: {
              examinations: 'currentexams'
            }
          }
        },
        /*views: {
         'examlistview@playground.exam': {
         template: 'Some useless Text'
         }
         },*/
        onEnter: function () {
          console.log('playground.exam.allcomponents entered');
        }
      });
    
    
  }// all routes
  
  
  function getfield(num) {
    return {
      label: 'Feld ' + num,
      avalues: [],
      values: [
        {
          name: 'bang'
        },
        {
          name: 'bong'
        },
        {
          name: 'bing'
        },
        {
          name: 'bung'
        },
        {
          name: 'beng'
        }
      ]
    };
  }
  
  
  function getfieldgroup(label) {
    return {
      label: label,
      fields: [
        getfield(2),
        getfield(3)
      ]
    };
  }
  
  
  function getFiles(num) {
    let files = [];
    
    for (let i = 0; i < num; i++) {
      if (i % 2) {
        files.push(getFile(true));
      }
      else {
        files.push(getFile(false));
      }
    }
    return files;
  }
  
  function getFile(inc) {
    return {
      label: 'ein label',
      fileid: '571de5357c01594fd0bbdf56',
      idinfiles: '571de5357c01594fd0bbdf5a',
      mimetype: 'image/jpeg',
      include: inc
    };
  }
  
  function getExam(open, active) {
    let exam = {
      _id: '571d67437c01594fd0bbdf47',
      created: '2016-04-25T00:39:31.368Z',
      templateid: '56a3aaca65db7f0fa271ee56',
      template: getTemplate(),
      files: getFiles(5),
      fdate: '25. Apr. 2016',
      diagnosis: 'total krank',
      type: 'Testexam',
      docid: '571d674d7c01594fd0bbdf48',
      patientid: '571d67207c01594fd0bbdf45',
      consultid: '571d67287c01594fd0bbdf46',
    };
    exam.open = open;
    exam.active = active;
    return exam;
  }
  
  function getExams() {
    return [
      getExam(true, true),
      getExam(true, false),
      getExam(false, true),
      getExam(false, false)
    ];
  }
  
  
  function getTemplate(files) {
    let template = {
      type: 'Test',
      displayname: 'Testexam',
      device: {
        label: 'Gerät',
        name: ''
      },
      shareid: '',
      fieldgroups: [
        getfieldgroup('fieldgroup1'), getfieldgroup('fieldgroup2')
      ],
      diagnosis: getDiagnoses(),
      recommendation: getRecommendations(),
      comment: getComment(),
      biopsy: getBiopsies()
    };
    
    template.loadfiles = files;
    if (files) {
      template.files = getFiles(5);
    }
    return template;
  }
  
  
  function getDiagnoses() {
    return {
      label: 'Diagnose',
      avalues: [
        {
          name: 'Krank'
        }
      ],
      values: [
        {
          name: 'Quux'
        },
        {
          name: 'Snafu'
        },
        {
          name: 'Qietsch'
        }
      ]
    };
  }
  
  
  function getComment() {
    return {
      label: 'Kommentar',
      avalues: [
        {
          name: 'Wichtiger Kommentar'
        }
      ],
      values: [
        {
          name: 'Quux'
        },
        {
          name: 'Snafu'
        },
        {
          name: 'Qietsch'
        }
      ]
    };
  }
  
  function getRecommendations() {
    return {
      label: 'Empfehlung',
      avalues: [
        {
          name: 'Ruhe'
        }
      ],
      values: [
        {
          name: 'Quux'
        },
        {
          name: 'Snafu'
        },
        {
          name: 'Qietsch'
        }
      ]
    };
  }
  
  function getBiopsies() {
    return {
      label: 'Biopsie',
      avalues: [{
        name: 'Speiseröhre'
      }],
      values: [
        {
          name: 'Speiseröhre'
        },
        {
          name: 'Magen'
        },
        {
          name: 'Darm'
        }
      ],
      biopsies: [
        {
          label: 'PE 1 Test ohne Share',
          avalues: [],
          values: []
        }
      ]
    };
  }
  
  


// klammerfriedhof
  
}());